export default __webpack_public_path__ + "static/media/fishes-mobile.f97b5e74.png";